import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Elige tu extracto',
    text: 'Revisa si buscas equilibrio, energía o enfoque.'
  }, {
    number: '02',
    title: 'Consulta por WhatsApp',
    text: 'Escríbenos para resolver dudas sobre disponibilidad, formato, precio y despacho.'
  }, {
    number: '03',
    title: 'Incorpora a tu rutina',
    text: 'Úsalo de forma responsable como complemento de bienestar.'
  }];
  return <section className="py-24 bg-brand-cream relative" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="text-center mb-16" data-id="element-96">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-heading font-bold text-brand-green" data-id="element-97">
            ¿Cómo comenzar?
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-98">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-beige z-0" data-id="element-99"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-100">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center text-3xl font-heading font-bold text-brand-gold shadow-md border-4 border-brand-cream mb-6" data-id="element-101">
                {step.number}
              </div>
              <h3 className="text-xl font-heading font-bold text-brand-green mb-3" data-id="element-102">
                {step.title}
              </h3>
              <p className="text-brand-brown/70 max-w-xs" data-id="element-103">{step.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}